function PrivacyPolicy() {
  return (
    <>
      <title>Privacy Policy - vidi3D</title>
      <meta name="description" content="vidi3D's privacy policy outlines how we collect and use your information when you interact with our services." />
      <meta name="keywords" content="privacy policy, data protection, information collection, vidi3D privacy" />
      <meta property="og:title" content="Privacy Policy - vidi3D" />
      <meta property="og:description" content="Learn about how vidi3D collects and protects your personal information." />
      <meta property="og:type" content="website" />
      <meta name="robots" content="noindex" />
      <link rel="canonical" href="https://vidi3d.com/privacy-policy" />

      <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-4xl mx-auto p-8">
          <h1 className="text-6xl font-bold text-brand text-center py-12 mb-8">Privacy Policy</h1>
          
          <div className="grid gap-8 md:grid-cols-2">
            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">Information We Collect</h2>
              </div>
              <p className="text-brand-dark mb-4">We collect information in the following ways:</p>
              <h3 className="font-semibold text-brand-dark mb-2">Contact Form Information:</h3>
              <ul className="space-y-3 text-brand-dark mb-4">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Name
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Email address
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Phone number (optional)
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Message content
                </li>
              </ul>
              <h3 className="font-semibold text-brand-dark mb-2">Automatically Collected Information:</h3>
              <ul className="space-y-3 text-brand-dark">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  IP address
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Browser type and version
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Device information
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Usage statistics
                </li>
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">How We Use Your Information</h2>
              </div>
              <p className="text-brand-dark mb-4">We use your information for:</p>
              <h3 className="font-semibold text-brand-dark mb-2">Service Provision:</h3>
              <ul className="space-y-3 text-brand-dark mb-4">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Responding to inquiries
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Providing requested services
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Processing transactions
                </li>
              </ul>
              <h3 className="font-semibold text-brand-dark mb-2">Communication:</h3>
              <ul className="space-y-3 text-brand-dark">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Service updates
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Marketing communications (with consent)
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Customer support
                </li>
              </ul>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">Data Protection & Security</h2>
              </div>
              <p className="text-brand-dark mb-4">We protect your data through:</p>
              <ul className="space-y-3 text-brand-dark mb-4">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  SSL encryption
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Secure data storage
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Regular security audits
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Access controls
                </li>
              </ul>
              <p className="text-brand-dark">We retain your data only for as long as necessary to provide our services and comply with legal obligations.</p>
            </section>

            <section className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-6">
                <div className="p-3 bg-brand/10 rounded-full mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-brand-dark">Your Rights</h2>
              </div>
              <p className="text-brand-dark mb-4">You have the right to:</p>
              <ul className="space-y-3 text-brand-dark mb-4">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Access your personal data
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Request data correction
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Request data deletion
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-brand rounded-full mr-3"></span>
                  Withdraw consent
                </li>
              </ul>
              <p className="text-brand-dark">Contact us at <a href="mailto:privacy@vidivenue.com" className="text-brand hover:underline">privacy@vidivenue.com</a> for privacy-related requests.</p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;